// Fuente ÚNICA de los estados de operación del conductor + helpers de conteo.
// Antes estaban duplicados/divergentes en 6+ archivos (mapa, histórico, cola offline),
// lo que causaba contadores inconsistentes. Importar siempre desde acá.

export const ESTADO_OP = Object.freeze({
    PENDIENTE: 'PENDIENTE',
    ASIGNADO: 'ASIGNADO',
    EN_CURSO: 'EN_CURSO',
    // Cierre: solo importa si se cumplió o no (independiente del tipo de operación).
    CUMPLIDO: 'CUMPLIDO',
    NO_CUMPLIDO: 'NO_CUMPLIDO',
});

// Estados habilitados para actuar: la operación todavía no está cerrada (incluye EN_CURSO,
// que quedó fichada pero sin finalizar y debe poder retomarse).
export const ESTADOS_ACCIONABLES = new Set([ESTADO_OP.PENDIENTE, ESTADO_OP.ASIGNADO, ESTADO_OP.EN_CURSO]);

// Estados finales REALES (operación cerrada). EN_CURSO NO es final.
export const ESTADOS_FINALES = new Set([ESTADO_OP.CUMPLIDO, ESTADO_OP.NO_CUMPLIDO]);

// Cierres exitosos (cumplido), para la barra de progreso "exitosas".
export const ESTADOS_EXITOSOS = new Set([ESTADO_OP.CUMPLIDO]);

// Lista plana (para usos que necesitan array, p. ej. la cola offline).
export const ESTADOS_FINALES_LIST = [...ESTADOS_FINALES];

export const esAccionable = (op) => ESTADOS_ACCIONABLES.has(op?.estadoOperacion);
export const esFinal = (op) => ESTADOS_FINALES.has(op?.estadoOperacion);
export const esExitosa = (op) => ESTADOS_EXITOSOS.has(op?.estadoOperacion);

// "Gestionadas" = cerradas en cualquier estado final (incluye no entregadas/no retiradas).
export const contarGestionadas = (ops = []) => ops.filter(esFinal).length;
// "Exitosas" = solo entregadas/retiradas.
export const contarExitosas = (ops = []) => ops.filter(esExitosa).length;

// Config visual por estado (ícono / color / label) para listados del conductor.
export const ESTADO_CFG = {
    CUMPLIDO:     { icon: 'bi-check-circle-fill', color: 'var(--color-green)',    label: 'Cumplido' },
    NO_CUMPLIDO:  { icon: 'bi-x-circle-fill',     color: 'var(--color-red)',      label: 'No cumplido' },
    EN_CURSO:     { icon: 'bi-hourglass-split',   color: 'var(--color-amber)',    label: 'En proceso — sin cerrar' },
    PENDIENTE:    { icon: 'bi-circle',            color: 'var(--color-gray-500)', label: 'Pendiente' },
    ASIGNADO:     { icon: 'bi-circle',            color: 'var(--color-gray-500)', label: 'Pendiente' },
};
